<script setup lang="ts">
import { Button } from '~ds/components/ui/button';

import { useSignupLink } from '~/composables/unified/useSignupLink';
import { ENTRY_CTA, ENTRY_SOURCE } from '~/utils/unified/entryTracking';

const { buildLink } = useSignupLink();
const loginLink = computed(() => buildLink({ entrySource: ENTRY_SOURCE.ROOT_UNIFIED, entryCta: ENTRY_CTA.YOUR_THING }));
</script>

<template>
  <div class="mx-10 flex flex-col gap-5 items-center">
    <KUICoreCardBackground background-image="/images/kui/unified/landing/accelerator-background.webp" sizes="100vw xl:1168px">
      <template #content>
        <div class="flex flex-col gap-12 items-center mx-10 my-15 lg:mx-21 lg:my-20 xl:my-33">
          <p class="mx-0 xl:mx-0 tracking-tight font-semibold text-center text-background text-4xl lg:text-5xl xl:text-6xl/16">
            {{ $t('unified.landing.yourThing.cardText') }}
          </p>
          <Button size="lg" as-child>
            <NuxtLink :to="loginLink">
              {{ $t('unified.landing.yourThing.cta') }}
            </NuxtLink>
          </Button>
        </div>
      </template>
    </KUICoreCardBackground>
  </div>
</template>
